import {errHandler} from './config'
import {getToken} from 'UTIL/common'

import {hashHistory} from 'react-router'
const xhr = ({url, body = null, method = 'POST'}) => {
    const defer = $.Deferred()

    console.log("请求服务端" + url + "       参数是" + body);
    $.ajax({
        type: method,
        url: url,
        data: body,
        // beforeSend: function (xhr) {                       //添加请求响应头中的自定义token
        //     xhr.setRequestHeader("Authorization", getToken());
        //     // xhr.setRequestHeader("accept-language","en-US")  //语言环境
        // },
        contentType: "application/json;charset=UTF-8",
        // xhrFields: { // 跨域允许带上 cookie
        //   withCredentials: [域名]
        // },
        crossDomain: true,
        //error:function(XMLHttpRequest, textStatus, errorThrown) {
            //console.log(textStatus,errorThrown)
            //console.log(console.log(JSON.stringify(XMLHttpRequest))); console.log("Error: " + errorThrown);
            //hashHistory.push("/login");
        //}

    })
        .done(defer.resolve)
         .fail(function(res) {
             console.log(res)
             var responseText = res.responseText;
             var message = JSON.parse(responseText).message;
             if(message == 'Unauthorized'){
                 sessionStorage.setItem('auth',message);
                 hashHistory.push('/login')
             }
         });

    return defer.promise()
}

export default xhr






// WEBPACK FOOTER //
// ./modules/services/xhr/jquery.js